import React, { useEffect } from "react";
import { Button, Input, Pagination, SelectMenu, Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import InboxTable from "./components/InboxTable";
import { useInbox } from "./hooks/useInbox";
import styles from "./Inbox.module.css";

const statusOptions = [
  { value: "all", label: "Tous" },
  { value: "OPEN", label: "Ouvertes" },
  { value: "CLOSED", label: "Cloturees" },
  { value: "ARCHIVED", label: "Archivees" },
];

// SelectMenu (zorni-components-lib) affiche `option.text`, pas `option.label` — c'est ce qui
// rendait ce select vide/inopérant (voir rapport de livraison).
const assignmentOptions = [
  { index: 0, value: "all", text: "Toutes" },
  { index: 1, value: "unassigned", text: "Non assignées" },
  { index: 2, value: "mine", text: "Assignées à moi" },
];

const Inbox = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    userId,
    conversations,
    conversationsLoading,
    error,
    currentPage,
    setCurrentPage,
    totalPages,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    assignmentFilter,
    setAssignmentFilter,
    selectedEstablishment,
    setSelectedEstablishment,
    establishmentFilterOptions,
    agentsById,
    isActionPending,
    onAssign,
    onArchive,
    onClose,
    onOpen,
  } = useInbox();

  useEffect(() => {
    if (error) {
      navigate("/error");
    }
  }, [error, navigate]);

  return (
    <div className={styles.page}>
      <div className={styles.headerCard}>
        <div>
          <Text as="h3" variant="heading" size="lg" weight="semibold">
            {t("inbox.title")}
          </Text>
          <Text size="sm" color="subtle">
            {t("inbox.subtitle")}
          </Text>
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.filterBar}>
          <div className={styles.searchWrapper}>
            <Input
              inputSize="small"
              iconLeft="iconSearch"
              placeholder="Rechercher..."
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
          </div>

          <div className={styles.filtersRight}>
            <SelectMenu t={t}
              inputSize="small"
              options={establishmentFilterOptions}
              value={selectedEstablishment}
              onChange={(value, option) => setSelectedEstablishment(option.value)}
            />

            <SelectMenu t={t}
              inputSize="small"
              options={assignmentOptions}
              value={assignmentFilter}
              onChange={(value, option) => setAssignmentFilter(option.value)}
            />

            <div className={styles.statusToggle}>
              {statusOptions.map((option) => (
                <Button
                  key={option.value}
                  size="small"
                  variant={statusFilter === option.value ? "primary" : "secondary"}
                  label={option.label}
                  onClick={() => setStatusFilter(option.value)}
                />
              ))}
            </div>
          </div>
        </div>

        <InboxTable
          items={conversations}
          loading={conversationsLoading}
          userId={userId}
          agentsById={agentsById}
          actionsDisabled={isActionPending}
          onOpen={(item) => onOpen(item.id)}
          onAssign={(item) => onAssign(item.id)}
          onArchive={(item) => onArchive(item.id)}
          onClose={(item) => onClose(item.id)}
        />

        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default Inbox;
